module.exports = __webpack_public_path__ + "img/medium-white.62da5126.svg";